/*-----------------------------------*\
  Designed by Shahjad Ansari
\*-----------------------------------*/

/*-----------------------------------*\
  #CUSTOM PROPERTY
\*-----------------------------------*/

import React from 'react';
import { Carousel } from 'react-bootstrap';
import img1 from '../assets/Images/Cement factory 1.webp';
import img2 from '../assets/Images/Crane Use for raw material 2.webp';
import img3 from '../assets/Images/Cement plat 3.webp';
import img4 from '../assets/Images/cement silos 4.webp';
import img5 from '../assets/Images/cement industry 5.webp';

import '../App.css';
import Hero from './Hero';

const Home = () => {
  return (
    <div className="Home">
      <Carousel wrap={true} interval={4000} pause={false} controls={true}>
        <Carousel.Item>
          <img className="d-block w-100 carousel" src={img1} alt="First slide" />
          <Carousel.Caption>
            <h3>Cement factory</h3>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100 carousel" src={img2} alt="Second slide" />
          <Carousel.Caption>
            <h3>Crane used for raw materials</h3>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100 carousel" src={img3} alt="Third slide" />
          <Carousel.Caption>
            <h3>Cement Plant</h3>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100 carousel" src={img4} alt="Fourth slide" />
          <Carousel.Caption>
            <h3>Cement silos</h3>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100 carousel" src={img5} alt="Fifth slide" />
          <Carousel.Caption>
            <h3>Cement industry</h3>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>

      <Hero />
    </div>
  );
};

export default Home;
